import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styles from '@dtsl/css-naos-scrollbar/dist/index.module.css';
const NaosScrollbar = /*#__PURE__*/forwardRef(function NaosScrollbar(props, ref) {
  const {
    children
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['sib-naos-scrollbar'],
    ref: ref
  }, children);
});
NaosScrollbar.propTypes = {
  children: PropTypes.node.isRequired
};
export default NaosScrollbar;